import { createRouter, createWebHistory } from "vue-router";
import { allRoute } from "@/router/routes";
import { hasPermission } from "@/helpers/permissions";
import http from "@/api/http";
import { getSsoUrl } from "@/helpers/helper";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

NProgress.configure({ showSpinner: false });

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: allRoute,
});

router.beforeEach(async (routeTo, routeFrom, next) => {
  NProgress.start();
  const previousPath = routeTo.fullPath;
  const title = routeTo.meta.title;
  if (title) {
    document.title = title.toString();
  }

  const authRequired = routeTo.matched.some((route) => route.meta.authRequired);

  if (authRequired) {
    try {
      await http().get("heartbeat");
    } catch (err) {
      return redirectToLogin(previousPath);
    }
  }

  const requiredPermission = routeTo.meta.permission as unknown as string;
  if (requiredPermission && !hasPermission(requiredPermission)) {
    return next({ name: "error.403" });
  }

  return next();
});

router.afterEach(() => {
  NProgress.done();
});

const redirectToLogin = async (previousPath: string) => {
  localStorage.removeItem("granary_capital");
  NProgress.done();
  window.location.href = getSsoUrl() + "/auth/sign-in";
};
export default router;
